import footerTheme from './footerTheme';
var footerDarkTheme = {
  footer: Object.assign({}, footerTheme.footer, {
    defaultFooter: {
      backgroundStart: '#1a1a1a',
      backgroundEnd: '#1a1a1a'
    }
  })
};
export default footerDarkTheme;